import React, { useState } from 'react';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import css from './PopupBanner.module.css';

const PopupBanner = () => {
  const [show, setShow] = useState(true);

  if (!show) return null;
  return (
    <div className={css.wrapper}>
      <div className={css.content}>
        <span>Create, share, and earn with Scanwow.</span>
        <a href={'/l/new'}>Join the creator community</a>

        <CloseRoundedIcon onClick={() => setShow(false)} className={css.icon} />
      </div>
    </div>
  );
};

export default PopupBanner;
